module.exports = __webpack_public_path__ + "static/media/HIWIOS.bf0b9694.svg";